import React from "react";

import { ChevronRight, ErrorOutlined, NotificationsActiveOutlined } from "@mui/icons-material";
import HeaderButton, { HeaderButtonProps } from "./HeaderButton";
import BNFab, { BNFabNavigationLink } from "../BNFab/BNFab";

interface Props {
  onNavigate?: (a?: any) => any;
  text: string;
  messageList: Array<{
    link: string;
    text: string;
    type: number;
  }>;
  isSpa: (path: string) => boolean;
  openMenuComponentSx?: HeaderButtonProps["iconButtonSx"];
}

const Notifications: React.FC<Props> = (props) => {
  const { messageList, onNavigate, isSpa, openMenuComponentSx } = props;

  if (!messageList || messageList.length < 1) {
    return null;
  }

  const actions: BNFabNavigationLink[] = messageList.map((message) => ({
    title: message.text,
    url: message.link,
    icon: message.type === 1 ? ErrorOutlined : ChevronRight,
    color: message.type === 1 ? "error.main" : undefined,
  }));
  return (
    <BNFab
      actions={actions}
      isSpa={isSpa}
      onNavigate={(label) => {
        onNavigate?.(label);
      }}
      OpenMenuComponent={
        <HeaderButton text={props.text} icon={NotificationsActiveOutlined} iconButtonSx={openMenuComponentSx} />
      }
    />
  );
};
export default Notifications;
